import { grey } from '@mui/material/colors';
import { auth } from '@onevision-resources/login';
import { QueryVariables } from 'src/graphql/types';

export const DEACTIVATED_USER_TEXT = 'deactivated';
export const DEACTIVATED_USER_COLOR = grey[700];

export function appendDisabledUserTextToName(userName = '') {
  return `${userName} (${DEACTIVATED_USER_TEXT})`;
}

export function extractDisabledUserTextFromName(value: string): string {
  return value?.replace(` (${DEACTIVATED_USER_TEXT})`, '');
}

export function hasDisabledText(value: string): boolean {
  return value.includes(DEACTIVATED_USER_TEXT);
}

export const getCurrentUserQueryVariables = (): QueryVariables => {
  return {
    params: {
      filters: [{ attribute: 'cognitoUsername', operator: '=', value: auth.getUsername() }],
      limit: 1,
    },
  };
};
